import type { Tokens, TokenizerExtension } from "marked";

let emojiRegex = /<(?<animated>a?):(?<name>[A-Za-z0-9_]+):(?<id>\d+)>/;
let tokenizerRule = new RegExp(`^${emojiRegex.source}`);

export type EmojiToken = Tokens.Generic & {
  id: BigInt;
  name: string;
  animated: boolean;
  inline: boolean;
};

export const emojiTokenizer: TokenizerExtension = {
  name: "emoji",
  level: "inline",
  start(src: string): number | undefined {
    return src.match(emojiRegex)?.index;
  },
  tokenizer(src: string): EmojiToken | undefined {
    let match = tokenizerRule.exec(src);
    if (!match?.groups?.id) return;

    return {
      type: "emoji",
      raw: match[0],
      id: BigInt(match.groups?.id),
      name: match.groups?.name,
      animated: match.groups?.animated == "a",
      inline: src.indexOf(">") != src.length,
    };
  },
};
